import {
	applicationService,
	loginService,
	nidService,
	registerService,
	emailService,
	phoneService,
	findAccountService,
	resetPasswordService,
	confirmService,
	allUsersService,
	resendEmail,
	getOrganizationService,
	maritalStatusService,
} from '../../services/userService';
import {
	APPLICANT,
	LOGIN,
	REGISTER,
	NID,
	EMAIL,
	PHONE,
	FIND_ACCOUNT,
	RESET_PASSWORD,
	CONFIRM_ACCOUNT,
	USERS,
	RESEND_EMAIL,
	NID_CHECK_MARITAL,	
} from './actiontype';
import { GET_ORGANIZATIONS } from "redux/actionTypes"

export const registerAction = data => {
	return {
		type: REGISTER,
		payload: registerService(data),
	};
};

export const loginAction = data => {
	return {
		type: LOGIN,
		payload: loginService(data),
	};
};
export const maritalStatusAction = (data) => {
    return async (dispatch) => {
        try {
            dispatch({ type: `${NID_CHECK_MARITAL}_PENDING` });
            const response = await maritalStatusService(data);
            // console.log('Dispatched response data:', response); // Log the response data

            // Assuming response is a string like 'Single', you can dispatch it directly
            dispatch({
                type: `${NID_CHECK_MARITAL}_FULFILLED`,
                payload: response, // Directly pass the string data here
            });
        } catch (error) {
            console.error('Error in maritalStatusAction:', error); // Log error here
            dispatch({
                type: `${NID_CHECK_MARITAL}_REJECTED`,
                payload: error,
            });
        }
    };
};

export const applicantAction = () => {
	return {
		type: APPLICANT,
		payload: applicationService(),
	};
};

export const nidAction = data => {
	return {
		type: NID,
		payload: nidService(data),
	};
};

export const emailAction = data => {
	return {
		type: EMAIL,
		payload: emailService(data),
	};
};

export const phoneAction = data => {
	return {
		type: PHONE,
		payload: phoneService(data),
	};
};

export const findAccountAction = data => {
	return {
		type: FIND_ACCOUNT,
		payload: findAccountService(data),
	};
};

export const resetPasswordAction = data => {
	return {
		type: RESET_PASSWORD,
		payload: resetPasswordService(data),
	};
};

export const confirmAction = data => {
	return {
		type: CONFIRM_ACCOUNT,
		payload: confirmService(data),
	};
};

export const usersAction = data => {
	return {
		type: USERS,
		payload: allUsersService(data),
	};
};

export const resendEmailAction = id => {
	return {
		type: RESEND_EMAIL,
		payload: resendEmail(id),
	};
};

export const getOrganizationAction = () => async (dispatch) => {
    try {
      dispatch({ type: GET_ORGANIZATIONS, payload: { loading: true } });
      const { data: body } = await getOrganizationService();

      const { status, message, data } = body;

      if (status === 200) {
        dispatch({
          type: GET_ORGANIZATIONS,
          payload: {
            loading: false,
            status,
            message,
            data,
          },
        });
      } else {
        dispatch({
          type: GET_ORGANIZATIONS,
          payload: { loading: false, status: "error" },
        });
      }
    } catch (error) {
      dispatch({
        type: GET_ORGANIZATIONS,
        payload: { loading: false, status: "error" },
      });
    }
  };
